import type {
  backendAppointmentDTO,
  backendBillDTO,
  backendBillLineDTO,
  backendConsultClubFootDTO,
  backendConsultOtherDTO,
  backendConsultRicketDTO,
  backendPatientFullDTO,
  backendPaymentDTO,
  backendPictureDTO,
  backendPricesByDateDTO,
  backendPriceSimpleDTO,
  backendSurgeryDTO
} from "../../backend/target/typescript/dto";
export type { Pojo } from "../objects-global";

export type Appointment = backendAppointmentDTO;
export type Bill = backendBillDTO;
export type BillLine = backendBillLineDTO;
export type ConsultClubfoot = backendConsultClubFootDTO;
export type ConsultOther = backendConsultOtherDTO;
export type ConsultRicket = backendConsultRicketDTO;
export type PatientFull = backendPatientFullDTO;
export type Patient = backendPatientFullDTO;
export type Payment = backendPaymentDTO;
export type Picture = backendPictureDTO;
export type Price = backendPriceSimpleDTO;
export type Surgery = backendSurgeryDTO;

export type Prices = backendPricesByDateDTO;

export const patientFilesList = [
  "appointment",
  "bill",
  "consult_clubfoot",
  "consult_other",
  "consult_ricket",
  "picture",
  "surgery"
] as const;

export type PatientFileType = (typeof patientFilesList)[number];

export type Consult = ConsultClubfoot | ConsultOther | ConsultRicket;
export type Timed = Appointment | Bill | Picture | Surgery | Consult;
export type PatientRelated = Timed;
